import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import AboutValaxis from './components/AboutValaxis';
import InvestmentFocus from './components/InvestmentFocus';
import ForBusinessOwners from './components/ForBusinessOwners';
import ForInvestors from './components/ForInvestors';
import Contact from './components/Contact';

const Divider = () => (
  <div className="max-w-[1120px] mx-auto px-10">
    <div className="h-px bg-[rgba(30,36,48,0.08)]" />
  </div>
);

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Schema.org JSON-LD for Organization
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Valaxis Group',
    url: import.meta.env.VITE_SITE_URL || 'https://valaxisgroup.com',
    logo: 'https://static.readdy.ai/image/cd71ffc29b4128737d19646fb970e806/23c6485507286e2714b90e8bd3ae7df8.png',
    description: 'Operator-led healthcare and technology platform focused on acquiring and scaling healthcare services and technology-enabled businesses.',
    founder: {
      '@type': 'Person',
      name: 'Steve Cagle',
      jobTitle: 'Founder & CEO',
      url: 'https://www.linkedin.com/in/steve-cagle/',
    },
    sameAs: [
      'https://www.linkedin.com/in/steve-cagle/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'steven@valaxisgroup.com',
      contactType: 'Business Inquiries',
    },
  };

  // Schema.org JSON-LD for WebPage
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Valaxis Group - Operator-Led Healthcare & Technology Platform',
    description: 'Valaxis Group is an operator-led healthcare and technology platform. Founded by an experienced multi-CEO with proven acquisition and exit track record.',
    url: import.meta.env.VITE_SITE_URL || 'https://valaxisgroup.com',
    lastReviewed: '2026-04-06',
    mainEntity: {
      '@type': 'Organization',
      name: 'Valaxis Group',
    },
  };

  // Schema.org JSON-LD for LocalBusiness
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'InvestmentFund',
    name: 'Valaxis Group',
    description: 'CEO-led acquisition initiative focused on acquiring and scaling healthcare, pharma services and technology-enabled services businesses.',
    url: import.meta.env.VITE_SITE_URL || 'https://valaxisgroup.com',
    logo: 'https://static.readdy.ai/image/cd71ffc29b4128737d19646fb970e806/23c6485507286e2714b90e8bd3ae7df8.png',
    founder: {
      '@type': 'Person',
      name: 'Steve Cagle',
    },
    areaServed: 'United States',
    serviceType: 'Healthcare and Technology Investment',
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <Header isScrolled={isScrolled} />
      <main className="pt-[100px]">
        <Hero />
        <Divider />
        <AboutValaxis />
        <Divider />
        <InvestmentFocus />
        <Divider />
        <ForBusinessOwners />
        <Divider />
        <ForInvestors />
        <Divider />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
